import * as React from 'react';
// @ts-expect-error
import {components} from 'react-select';
// @ts-expect-error
import type {OptionProps} from 'react-select';

import {colors} from '../colors/colors';

import styles from './color-named-option.module.css';

export function ColorNamedOption(props: OptionProps) {
    return (
        <components.Option {...props}>
            <div className='flex align-center'>
                <div
                    // @ts-expect-error
                    style={{backgroundColor: colors[props.data.colorName]}}
                    className={styles['color-name-option-dot']}
                />
                <div>{props.label}</div>
            </div>
        </components.Option>
    );
}
